import { useQuery } from "@tanstack/react-query";
import { http } from "../../../../../../services/HttpService";
import { HTTP_ENDPOINTS, QUERY_KEYS } from "../../../../../../consts/api";

export const useSunbitWallet = (clientId, options = {}) => {
  const res = useQuery(
    [QUERY_KEYS.sunbit.getWallet, clientId],
    () => http.get(HTTP_ENDPOINTS.sunbit.getWallet(clientId)),
    { cacheTime: 0, select: (res) => res.data.data, ...options },
  );
  return res;
};
